export const DEFAULT_FIELD_VALUES: Record<string, unknown> = {
  amount: 0,
  currency: 'USD',
  region: 'US-West',
  stringField: '',
  height: 200,
  width: 200,
};
